import {Avatar} from '@components/common/base/avatar'
import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {TableUserInfo} from '../types'

export const UserInfo = observer(({user}: {user: TableUserInfo}) => {
  const Line = ({
    title,
    children
  }: {
    title: string
    children: React.ReactNode
  }) => (
    <div className="mb-4 text-obscure-constant-old truncate">
      <span>{title}</span>: <span className="font-semibold">{children}</span>
    </div>
  )

  return (
    <div className="inline-flex text-12 text-obscure-constant-old">
      <div className="mr-8">
        <Avatar userId={user.userId} hideOutline hideStatus />
      </div>
      <div className="max-w-240">
        <div className="mb-6 font-semibold text-on-color">{user.userName}</div>
        {user.departments && (
          <Line title={Lang.msg.companies.department}>{user.departments}</Line>
        )}
        {user.position && (
          <Line title={Lang.msg.companies.position}>{user.position}</Line>
        )}
        {user.role && (
          <Line title={Lang.msg.permission.headerRole}>{user.role}</Line>
        )}
      </div>
    </div>
  )
})
